import React, { useEffect } from 'react';
import importAffirmScript from '../../utils/affirmScript';
import useStyles from './index.style';

const AffirmBox = ({ balance, currency }) => {
  const classes = useStyles();
  const { REACT_APP_API_KEY_AFFIRM, REACT_APP_AFFIRM_SCRIPT } = process.env;
  const { affirm } = window;

  useEffect(() => {
    importAffirmScript(REACT_APP_API_KEY_AFFIRM, REACT_APP_AFFIRM_SCRIPT);
    return () => {
      if (window.affirm) {
        window.affirm?.ui?.modal.close();
      }
    };
  }, []);

  useEffect(() => {
    if (affirm) {
      affirm.ui.ready(() => {
        affirm.ui.refresh();
      });
    }
  }, [affirm]);

  const showAffirm = (currencyCode, amountBalance) => {
    return currencyCode === 'USD' && amountBalance >= 50;
  };

  const isAfirm = showAffirm(currency, balance);

  return (
    <div className={isAfirm && classes.affirmContent}>
      <div className="footerTitle">
        {/* Uncomment the following lines to view a dummy affirm text */}
        {/* <span id="affirm-span-text">
          As low as 0% APR or <span className="affirm-span-text">$320/mo</span> with Affirm.
        </span> */}
        {isAfirm && (
          <div className={classes.affirmAnnounceWidth}>
            <div className="affirmLink" data-testid="affirmLink-test">
              <span
                id="affirm-span-text"
                className="affirm-as-low-as"
                data-page-type="product"
                data-learnmore-show="false"
                aria-hidden="true"
                label="button"
                role="button"
                tabIndex="0"
                data-amount={Number(balance).toFixed(2).toString().replace('.', '')}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AffirmBox;
